import React from 'react'
import {useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'
import WechatPopover from '@/components/WechatPopover'
import logoImg from '@/assets/img/logo.png'
import wechatImg from '@/assets/img/icon/wechat.png'
import instagramImg from '@/assets/img/icon/instagram.png'
import facebookImg from '@/assets/img/icon/facebook.png'
import pinterestImg from '@/assets/img/icon/pinterest.png'
import tiktokImg from '@/assets/img/icon/tiktok.png'
import twitterImg from '@/assets/img/icon/twitter.png'
import youtubeImg from '@/assets/img/icon/youtube.png'

import {
  IG_LINK, FACEBOOK_LINK, PINTEREST_LINK, TK_LINK, TWITTER_LINK, YT_LINK
} from '@/constants'

const defaultProps = {
  isShowFooterTop: true,
};

export default function Footer(props) {
  const options = Object.assign({}, defaultProps, props);
  const navigate = useNavigate()
  const location = useLocation()
  const {t} = useTranslation()
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'footer-mobile-container' : 'footer-container'
  const handleContactUsClick = () => {
    const path = '/contactUs'
    if (location.pathname === path) {
      return
    }
    navigate(path)
  }

  const handleAboutUsClick = () => {
    const path = '/aboutUs'
    if (location.pathname === path) {
      return
    }
    navigate(path)
  }

  return (
    <div className={rootClassName} id={'page-footer'}>
      {
        options.isShowFooterTop &&
        <div className={'footer-top-container'}>
          <div className={'footer-top-content-container'}>
            <div className={'footer-top-content-left-container'}>
              {/*<div className={'footer-top-content-left-logo-container'}>
                <img src={logoImg} alt="logo" />
              </div>
              <div className={'footer-top-content-left-des'}>
                Smiling Home was founded in Los Angeles, California in 2012. Since then with a warm heart and dedication, we have successfully provided the market with a series of home linen products, Quilts, Bedspreads, Blankets, Curtains, Sheets, and more! Smiling Home has achieved a global presence in the Home Decor industry and has become a well-known brand name in our dear customer's hearts. 
              </div>*/}
              <div className={'footer-top-content-left-get-in-touch-container'}>
                <div className={'footer-top-content-title'}>{t('SOCIAL MEDIAS')}</div>
                <div className={'footer-top-content-left-get-in-touch-list'}>
                  {/* <WechatPopover>
                    <div 
                      className={'footer-top-content-left-get-in-touch-item-container'}>
                      <img src={wechatImg} alt="wechat" />
                    </div>
                  </WechatPopover> */}
                  <div 
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open('')}>
                    <img src={instagramImg} alt="instagram" />
                  </div>
                  <div
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open('')}>
                    <img src={facebookImg} alt="facebook" />
                  </div>
                  <div
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open('')}>
                    <img src={tiktokImg} alt="tiktok" />
                  </div>
                  {/* <div
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open(PINTEREST_LINK)}>
                    <img src={pinterestImg} alt="pinterest" />
                  </div>
                  <div
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open(TK_LINK)}>
                    <img src={tiktokImg} alt="tiktok" />
                  </div>
                  <div
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open(TWITTER_LINK)}>
                    <img src={twitterImg} alt="twitter" />
                  </div>
                  <div
                    className={'footer-top-content-left-get-in-touch-item-container'}
                    onClick={() => window.open(YT_LINK)}>
                    <img src={youtubeImg} alt="youtube" />
                  </div>
                  */}
                </div>
              </div>
            </div>
            <div className={'footer-top-content-right-container'}>
              <div className={'footer-top-content-right-working-hours-container'}>
                <div className={'footer-top-content-title'}>{t('WORKING HOURS')}</div>
                <div className={'footer-top-content-right-working-hours-item-container'}>
                  {t('Monday - Sunday')}
                  <span>: {t('9am - 5pm')}</span>
                </div>
                <div className={'footer-top-content-right-working-hours-item-container'}>
                  {t('Sunday')}
                  <span>: {t('9am - 5pm')}</span>
                </div>
              </div>
              <div className={'footer-top-content-right-contact-us-container'}>
                
                <div className={'footer-top-content-title footer-link'} onClick={handleAboutUsClick}>{t('ABOUT US')}</div>
                {/*  
                  <div className={'footer-top-content-title footer-link'} onClick={handleContactUsClick}>{t('CONTACT US')}</div>
                  <div className={'footer-top-content-right-contact-us-title'}>
                */}
                <div className={'footer-top-content-right-contact-us-des'}>
                  2110 Edwards Ave, South El Monte CA91733
                </div>
                <div className={'footer-top-content-right-contact-us-des'}>
                  {t('Email')}: test1234@gmail.com
                </div>
                <div className={'footer-top-content-right-contact-us-des'}>
                  {t('Store')} {t('Phone')}: (111) 111 - 1111
                </div>
                {/*<div className={'footer-top-content-right-contact-us-des'}>
                  {t('Sales')} {t('Phone')}: (222) 222 - 2222
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      }
      <div className={'footer-bottom-container'}>
        © 2026 Apoodr | Powered by Truckxi
      </div>
    </div>
  )
}
